"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columns = exports.INITIAL_VISIBLE_COLUMNS = void 0;
exports.INITIAL_VISIBLE_COLUMNS = ["attribute_key", "old_value", "new_value", "status", "actions"];
exports.columns = [
    { name: "Attribute", uid: "attribute_key", sortable: true },
    { name: "Old Value", uid: "old_value", sortable: true },
    { name: "New Value", uid: "new_value", sortable: true },
    { name: "Status", uid: "status", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
